import { Component } from "@angular/core";

@Component({
  selector: "bit-menu-divider",
  templateUrl: "./menu-divider.component.html",
})
export class MenuDividerComponent {}
